import { Component, OnInit } from "@angular/core";
import { FormGroup, FormArray, Validators } from "@angular/forms";
import { MatRadioChange } from "@angular/material/radio";
import { MemberappBaseComponent } from "../groupportal-base/groupportal-base.component";
import {
	ChapterDetails,
	ChapterInfo
} from "../../../shared/models/chapter-details";

@Component({
	selector: "app-chapters .d-flex.pl-3",
	templateUrl: "./component1.component.html",
	styleUrls: ["./component1.component.scss"]
})
export class Component1Component extends MemberappBaseComponent {
	chapterDetails: ChapterDetails;
	chapterForm: FormGroup;

	get chapterFormArray(): FormArray {
		return this.chapterForm.get("chapters") as FormArray;
	}

	ngOnInit() {
		//this.loggerService.logInfo(this.groupPortalDataService.memberAppData);

		//reset
		this.resetForm();

		//subscriptions
	}

	resetForm() {
		//this.chaptersService.giveSomeTestData();

		this.chapterForm = this.fb.group({
			chapters: this.fb.array(
				this.chapterDetails.chapters.map(a => this.createItem(a))
			)
		});

		this._setPrimary();
	}

	createItem(ci: ChapterInfo): FormGroup {
		return this.fb.group({
			id: ci.id,
			name: ci.name,
			code: ci.code,
			selected: [ci.selected],
			isPrimary: [ci.isPrimary, Validators.required]
		});
	}

	changePrimary(event: MatRadioChange) {
		this._setPrimary(event.value);
	}

	_setPrimary(id?: any) {
		if (!id) {
			if (this.chapterDetails.chapters.length == 1) {
				this.chapterDetails.chapters[0].isPrimary = true;
				this.chapterDetails.chapters[0].selected = true;
			}

			let _c = this.chapterDetails.chapters.filter(a => a.isPrimary)[0];
			if (_c) {
				id = _c.id;
			}
		}

		this.chapterFormArray.controls.forEach(ctrl => {
			ctrl.get("isPrimary").setValue(ctrl.get("id").value == id);
		});

		//Mark Primary as Selected
		if (id) {
			this.chapterFormArray.controls
				.filter(ctrl => ctrl.get("id").value == id)[0]
				.get("selected")
				.setValue(true);
		}
	}

	chapterChange() {
		this.groupPortalDataService.navigateToRoute("changeaddress");
	}

	prepareDataModel(): ChapterDetails {
		let p: ChapterDetails = Object.assign({},
			this.chapterDetails,
			this.chapterForm.value) as ChapterDetails;
		return p;
	}

	save() {
		super.onSave(this.chapterForm);

		this.chapterDetails = this.prepareDataModel();
		if (this.chapterDetails.chapters.filter(a => a.selected).length == 0) {
			this.globalDomOpsService.notify(
				"Please select a Primary Chapter",
				"",
				"warning");
			return;
		}

		this.onSaveComplete();
	}

	onSaveComplete() {
		this.groupPortalDataService.memberAppData.chapterDetails = this.chapterDetails;
		this.globalDomOpsService.notify("Chapter Information Updated");
		this.groupPortalDataService.navigateToRoute("component2");
	}

	getQuote() {

		let htmlBody = `<h1><b>My First Heading </b></h1><p> My first paragraph. </p ><u> Funny How!!</u>`;
		htmlBody = btoa(htmlBody);
		let param = { htmlbody: htmlBody, filename: 'Quote000' };
		this.dataService.post(
			param,
			"http://localhost/acep/utils/api/s3/HtmlToPdf");

	}
}
